export enum RFSStatus {
  NotDefined = 0,
  InReview = 1,
  AwaitingApproval = 2,
  Rejected = 3,
  AwaitingCandidates = 4,
  NoCandidates = 5,
  Active = 6,
  NoSelection = 7,
  AssignmentCreated = 8,
  Cancelled = 9,
  NoResponse = 10,
  ConsultantCreated = 11,
}
